<template>
  <div class="btn-box">
    <a-tooltip :title="tip">
      <a-popconfirm
        :title="confirm"
        ok-text="确定"
        cancel-text="取消"
        @confirm="onClick"
        v-if="confirm"
      >
        <a-button
          style="display: block"
          :danger="danger"
          :type="type"
          :size="size"
          :loading="loading"
          :disabled="disabled"
        >
          <template #icon>
            <sc-icon v-if="icon" :type="icon" :style="iconStyle" />
          </template>
          {{ text }}
        </a-button>
      </a-popconfirm>
      <a-button
        style="display: block"
        :danger="danger"
        :type="type"
        :size="size"
        @click="onClick"
        :loading="loading"
        :disabled="disabled"
        v-else
      >
        <template #icon>
          <sc-icon v-if="icon" :type="icon" :style="iconStyle" />
        </template>
        {{ text }}
        <slot />
      </a-button>
    </a-tooltip>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const props = withDefaults(
  defineProps<{
    danger?: boolean;
    icon?: string;
    text?: string;
    tip?: string;
    iconStyle?: any;
    size?: 'large' | 'middle' | 'small';
    type?: 'primary' | 'ghost' | 'dashed' | 'link' | 'text' | 'default';
    confirm?: string;
    handler?: () => Promise<void> | void;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  }
);
const loading = ref(false);

async function onClick() {
  if (!props.handler) {
    return;
  }
  loading.value = true;
  try {
    await props.handler();
  } finally {
    loading.value = false;
  }
}
</script>

<style lang="scss" scoped>
.btn-box {
  display: inline-block;
}
:deep(.ant-btn.ant-btn-link) {
  line-height: 20px;
  height: 20px;
}
</style>
